import React from "react";

interface SpecialtyTagProps {
  name: string;
}

const SpecialtyTag: React.FC<SpecialtyTagProps> = ({ name }) => {
  return (
    <div className="bg-green-150 flex flex-col justify-center rounded-lg px-1.5 py-1">
      <div className="flex items-center gap-1">
        <span className="mx-1.5 my-auto self-stretch">{name}</span>
      </div>
    </div>
  );
};

export default SpecialtyTag;
